import script from "./object_video.vue?vue&type=script&setup=true&lang=js"
export * from "./object_video.vue?vue&type=script&setup=true&lang=js"

import "./object_video.vue?vue&type=style&index=0&id=94172954&scoped=true&lang=scss"

import exportComponent from "/home/dmytro/Projects/gcs/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94172954"]])

export default __exports__